import styles from './StatusCellRenderer.module.css';
import { Box, Text, Tooltip } from '@chakra-ui/react';

// Status mapping for isActive
const Statuses = {
    true: { type: 'active', displayedName: 'Active' },
    false: { type: 'inactive', displayedName: 'Inactive' },
};

const StatusCellRenderer = ({
    value,
    noCircle,
    statuses = false,
    fitText = false,
    isSmall = false,
}) => {
    const status = statuses ? statuses[value] : Statuses[value];

    const content = (
        <Box
            className={`${styles.tag} ${styles[status?.type + 'Tag']}`}
            sx={{
                display: 'flex',
                alignItems: noCircle ? 'center' : null,
                justifyContent: noCircle ? 'center' : null,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                minWidth: fitText && '110px',
                width: fitText && 'fit-content',
            }}>
            {!noCircle && (
                <div
                    className={`${styles.circle} ${styles[status?.type + 'Circle']}`}
                />
            )}
            {!isSmall ? (
                <Text fontSize="12px" isTruncated>
                    {status?.displayedName}
                </Text>
            ) : (
                <Text
                    fontSize="12px"
                    height="20px"
                    lineHeight="20px"
                    isTruncated
                    sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}>
                    {status?.displayedName}
                </Text>
            )}
        </Box>
    );

    return (
        <Tooltip label={status?.displayedName} aria-label="Status tooltip">
            {content}
        </Tooltip>
    );
};

export default StatusCellRenderer;
